import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/SocialAuthTalentSignInInstagram.graphql';
import { Mutation, MutationsocialAuthTalentSignInInstagramArgs } from '../../__generated__/globalTypes';

export const useSocialAuthTalentSignInInstagramMutation = (
  options?: MutationHookOptions<Mutation, MutationsocialAuthTalentSignInInstagramArgs>
) => {
  const [callSocialAuthTalentSignInInstagram, result] = useMutation<
    Mutation,
    MutationsocialAuthTalentSignInInstagramArgs
  >(MUTATION, options);

  return { callSocialAuthTalentSignInInstagram, ...result };
};

export type SocialAuthTalentSignInInstagramMutationFunction = Mutation['socialAuthTalentSignInInstagram'];
